import { AxiosInstance } from "axios";
import { OnboardingStatusResponse } from "./OnboardingStatusDomain";

export class OnboardingStatusService {
  constructor(private api: AxiosInstance) {}

  getOnboardingStatus(organisationNumber: string): Promise<OnboardingStatusResponse> {
    return this.api.get(`/onboarding-status/${organisationNumber}`).then((response) => {
      return response.data;
    });
  }

  onboardCompanyRoles(organisationNumber: string): Promise<void> {
    return this.api.post(`/onboarding-status/complete-company-roles/${organisationNumber}`);
  }

  onboardShareholders(organisationNumber: string): Promise<void> {
    return this.api.post(`/onboarding-status/complete-shareholders/${organisationNumber}`);
  }

  markShareholdersIncomplete(organisationNumber: string): Promise<void> {
    return this.api.post(`/onboarding-status/incomplete-shareholders/${organisationNumber}`);
  }

  onboardArticlesOfAssociation(organisationNumber: string): Promise<void> {
    return this.api.post(
      `/onboarding-status/complete-articles-of-association/${organisationNumber}`,
    );
  }
}
